import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  saverContent: {
    display: 'flex',
    alignItems: 'stretch'
  },
  saveImgWrapper: {
    textAlign: 'center',
    padding: '24px 32px',
    borderRight: "1px solid ".concat(palette.shades[300]),
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    [breakpointsFunc.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  saverImg: {
    marginTop: '10px'
  },
  carouselWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'calc(100% - 225px)',
    [breakpointsFunc.breakpoints.down('sm')]: {
      padding: '24px 0',
      width: 'calc(100%)'
    }
  }
});
export default useStyles;